import { Injectable } from '@angular/core';

export type LoadingObject = Record<string, boolean>;


@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  public isAnythingLoading(loadingObject:LoadingObject): boolean {
    if (!loadingObject) { throw new Error('Loading object is undefined'); }
    for (let something in loadingObject) {
        if (loadingObject[something]) {
            return true;
        }
    }
    return false;
    }

  public setLoadingStatus(key: string, status: boolean, loadingObject : LoadingObject): LoadingObject {
        return {
            ...loadingObject,
            [key]: status
        };
    }

}